import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FuelSystemsService } from './fuel-systems.service';

@Component({
  selector: 'app-fuel-systems',
  templateUrl: './fuel-systems.component.html',
  styleUrls: ['./fuel-systems.component.scss']
})
export class FuelSystemsComponent implements OnInit {
  selectedBtn: string = 'sales';
  selectedDi: string = 'All';
  selectedValues: any = {};
  formDetails: any = {};
  customerByTrend: any = {};
  algorithm: any = {};
  baseUrl: string = '/nrp/components/fuelsystems/';
  title: string = 'Customer';
  salesReal: any = {};
  marginReal: any = {};
  dailySales: any = {};
  top5: any = {};
  qParam: any = {};
  dataLoaded: boolean = false;
  reset: number = 0;
  top5Loaded = false;
  detailTiltle: string = '';
  filter: any;
  currentFilter: string = '';
  radio: any;
  lob: string = '';
  salesPercentValTop: any = {};
  salesPercentValBottom: any = {};
  marginPercentValTop: any = {};
  marginPercentValBottom: any = {};
  customerNames: any = {};

  constructor(
    private service: FuelSystemsService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.filter = params['filter'];
      if (this.filter == '') {
        this.lob = 'lob_l1';
      } else {
        this.lob = 'lob';
      }
    });
  }

  private normalizeMulti(value: any): string[] {
    if (!Array.isArray(value) || value.length === 0) return ['All'];
    return value;
  }

  ngOnInit(): void {
    // Commented out dropdowns: ctt_reported, model_type, displacement, certification
    // this.selectedValues['ctt_reported'] = ['All'];
    // this.selectedValues['displacement'] = ['All'];
    // this.selectedValues['certification'] = ['All'];
    // this.selectedValues['model_type'] = ['All'];
    
    // Active dropdowns in desired sequence
    this.selectedValues['internal_external'] = ['All'];
    this.selectedValues['customer_channel'] = ['All'];
    this.selectedValues['lob'] = ['All'];
    this.selectedValues['customer_group'] = ['All'];
    this.selectedValues['customer_name'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['product_line'] = ['All'];
    this.selectedValues['selling_location'] = ['All'];
    this.selectedValues['part_no_ID_21'] = ['All'];

    this.qParam = {
      // Commented out: displacement, certification, ctt_reported, model_type
      // displacement: this.selectedValues.displacement,
      // certification: this.selectedValues.certification,
      // ctt_reported: this.selectedValues.ctt_reported,
      // model_type: this.selectedValues.model_type,
      
      // Active parameters
      internal_external: this.normalizeMulti(this.selectedValues.internal_external),
      customer_channel: this.normalizeMulti(this.selectedValues.customer_channel),
      lob: this.normalizeMulti(this.selectedValues.lob),
      customer_group: this.normalizeMulti(this.selectedValues.customer_group),
      customer_name: this.normalizeMulti(this.selectedValues.customer_name),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      product_line: this.normalizeMulti(this.selectedValues.product_line),
      selling_location: this.normalizeMulti(this.selectedValues.selling_location),
      part_no_ID_21: this.normalizeMulti(this.selectedValues.part_no_ID_21),
    };
    this.searchFilters();
    this.getCustomerByTrend();
    this.getAlgorithms();
    this.getSalesRealization();
  }

  searchFilters() {
    // Commented out dropdowns: displacement, certification, ctt_reported, model_type
    
    // Active dropdowns in desired sequence
    let internal_external = {
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let customer_channel = {
      internal_external: this.selectedValues.internal_external,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let lob = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let customer_group = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let customer_name = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let ecc = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let product_line = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      selling_location: this.selectedValues.selling_location,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let selling_location = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      part_no_ID_21: this.selectedValues.part_no_ID_21,
    };

    let part_no_ID_21 = {
      internal_external: this.selectedValues.internal_external,
      customer_channel: this.selectedValues.customer_channel,
      lob: this.selectedValues.lob,
      customer_group: this.selectedValues.customer_group,
      customer_name: this.selectedValues.customer_name,
      ecc: this.selectedValues.ecc,
      product_line: this.selectedValues.product_line,
      selling_location: this.selectedValues.selling_location,
    };

    // Commented out dropdown calls
    // if (this.currentFilter != 'certification') {
    //   certification['current_dropdown'] = 'certification';
    //   this.getDropdowndetails(certification);
    // }
    // if (this.currentFilter != 'displacement') {
    //   displacement['current_dropdown'] = 'displacement';
    //   this.getDropdowndetails(displacement);
    // }
    // if (this.currentFilter != 'ctt_reported') {
    //   ctt_reported['current_dropdown'] = 'ctt_reported';
    //   this.getDropdowndetails(ctt_reported);
    // }
    // if (this.currentFilter != 'model_type') {
    //   model_type['current_dropdown'] = 'model_type';
    //   this.getDropdowndetails(model_type);
    // }

    // Active dropdown calls in desired sequence
    if (this.currentFilter != 'internal_external') {
      internal_external['current_dropdown'] = 'internal_external';
      this.getDropdowndetails(internal_external);
    }
    if (this.currentFilter != 'customer_channel') {
      customer_channel['current_dropdown'] = 'customer_channel';
      this.getDropdowndetails(customer_channel);
    }
    if (this.currentFilter != 'lob') {
      lob['current_dropdown'] = 'lob';
      this.getDropdowndetails(lob);
    }
    if (this.currentFilter != 'customer_group') {
      customer_group['current_dropdown'] = 'customer_group';
      this.getDropdowndetails(customer_group);
    }
    if (this.currentFilter != 'customer_name') {
      customer_name['current_dropdown'] = 'customer_name';
      this.getDropdowndetails(customer_name);
    }
    if (this.currentFilter != 'ecc') {
      ecc['current_dropdown'] = 'ecc';
      this.getDropdowndetails(ecc);
    }
    if (this.currentFilter != 'product_line') {
      product_line['current_dropdown'] = 'product_line';
      this.getDropdowndetails(product_line);
    }
    if (this.currentFilter != 'selling_location') {
      selling_location['current_dropdown'] = 'selling_location';
      this.getDropdowndetails(selling_location);
    }
    if (this.currentFilter != 'part_no_ID_21') {
      part_no_ID_21['current_dropdown'] = 'part_no_ID_21';
      this.getDropdowndetails(part_no_ID_21);
    }
  }

  getDropdowndetails(type) {
    this.service
      .getDropDown(type, this.baseUrl + 'dropdown')
      .subscribe((results) => {
        let channel: any[] = [];

        // Commented out dropdowns: certification, displacement, ctt_reported, model_type
        // if (type.current_dropdown == 'certification')
        //   channel = results.certification;
        // if (type.current_dropdown == 'displacement')
        //   channel = results.displacement;
        // if (type.current_dropdown == 'ctt_reported')
        //   channel = results.ctt_reported;
        // if (type.current_dropdown == 'model_type')
        //   channel = results.model_type;

        // Active dropdowns
        if (type.current_dropdown == 'customer_name')
          channel = results.customer_name;
        if (type.current_dropdown == 'internal_external') channel = results.internal_external;
        if (type.current_dropdown == 'lob') channel = results.lob;
        if (type.current_dropdown == 'customer_channel')
          channel = results.customer_channel;
        if (type.current_dropdown == 'customer_group')
          channel = results.customer_group;
        if (type.current_dropdown == 'ecc')
          channel = results.ecc;
        if (type.current_dropdown == 'product_line')
          channel = results.product_line;
        if (type.current_dropdown == 'selling_location')
          channel = results.selling_location;
        if (type.current_dropdown == 'part_no_ID_21')
          channel = results.part_no_ID_21;

        const resp = [...new Set(channel)];

        // Commented out dropdown form details
        // if (type.current_dropdown == 'displacement') {
        //   this.formDetails['displacement'] =
        //     resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        // }
        // if (type.current_dropdown == 'certification') {
        //   this.formDetails['certification'] =
        //     resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        // }
        // if (type.current_dropdown == 'ctt_reported') {
        //   this.formDetails['ctt_reported'] =
        //     resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        // }
        // if (type.current_dropdown == 'model_type') {
        //   this.formDetails['model_type'] =
        //     resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        // }

        // Active dropdown form details
        if (type.current_dropdown == 'customer_name') {
          this.formDetails['customer_name'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'internal_external') {
          this.formDetails['internal_external'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'lob')
          this.formDetails['lob'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'customer_channel')
          this.formDetails['customer_channel'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'customer_group')
          this.formDetails['customer_group'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'ecc')
          this.formDetails['ecc'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'product_line')
          this.formDetails['product_line'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'selling_location')
          this.formDetails['selling_location'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'part_no_ID_21')
          this.formDetails['part_no_ID_21'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));

        this.formDetails = { ...this.formDetails };
      });
  }

  searchSalesData(event) {
    this.dataLoaded = false;
    this.currentFilter = event.type;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.qParam = {
      // Commented out parameters: displacement, certification, ctt_reported, model_type
      // displacement: this.selectedValues.displacement,
      // certification: this.selectedValues.certification,
      // ctt_reported: this.selectedValues.ctt_reported,
      // model_type: this.selectedValues.model_type,
      
      // Active parameters
      internal_external: this.normalizeMulti(this.selectedValues.internal_external),
      customer_channel: this.normalizeMulti(this.selectedValues.customer_channel),
      lob: this.normalizeMulti(this.selectedValues.lob),
      customer_group: this.normalizeMulti(this.selectedValues.customer_group),
      customer_name: this.normalizeMulti(this.selectedValues.customer_name),
      ecc: this.normalizeMulti(this.selectedValues.ecc),
      product_line: this.normalizeMulti(this.selectedValues.product_line),
      selling_location: this.normalizeMulti(this.selectedValues.selling_location),
      part_no_ID_21: this.normalizeMulti(this.selectedValues.part_no_ID_21),
    };

    this.searchFilters();
    this.getCustomerByTrend();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.getAlgorithms();

    if (this.selectedDi !== 'All') {
      this.searchDimension(this.selectedDi);
    }
  }

  getAlgorithms() {
    this.dataLoaded = false;
    this.service
      .getAlgorithmsValues(this.qParam, this.baseUrl + 'algorithm')
      .subscribe((results) => {
        this.algorithm = results;
        this.dataLoaded = true;
      });
  }

  getCustomerByTrend() {
    this.customerByTrend = [];
    this.top5Loaded = false;
    this.service
      .getCustomerByTrendBridgeValues(this.qParam, this.baseUrl + 'customertrend')
      .subscribe((results) => {
        this.customerByTrend = results;
        this.top5Loaded = true;
      });
  }

  getSalesRealization() {
    this.salesReal = [];
    this.dataLoaded = false;

    this.service
      .getSalesBridgeValues(this.qParam, this.baseUrl + 'salesrealisation')
      .subscribe((results) => {
        this.salesReal = results;
        this.dataLoaded = true;
      });
  }

  getMarginRealization() {
    this.marginReal = [];
    this.dataLoaded = false;
    this.service.getMarginBrigeValues(this.qParam, this.baseUrl + 'marginrealisation')
      .subscribe((results) => {
        this.marginReal = results;
        this.dataLoaded = true;
      });
  }

  salesButton() {
    this.selectedBtn = 'sales';
    this.getSalesRealization();
  }

  marginButton() {
    this.selectedBtn = 'margin';
    this.getMarginRealization();
  }

  byTrend() {
    this.selectedDi = 'All';
    this.qParam.lob = ['All'];
    this.getCustomerByTrend();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.radio = null;
  }

  searchDimension(event) {
    this.qParam = {
      model_type: this.normalizeMulti(this.selectedValues.model_type),
      certification: this.normalizeMulti(this.selectedValues.certification),
      product_line: this.normalizeMulti(this.selectedValues.product_line),
      lob: this.normalizeMulti(this.selectedValues.lob),
      customer_name: this.normalizeMulti(this.selectedValues.customer_name),
    };
    this.selectedDi = event;
    this.top5Loaded = false;

    this.top5 = [];
    this.service
      .getTop5Values(this.qParam, this.baseUrl + 'sales/top5/' + event)
      .subscribe((results) => {
        this.top5 = results;
        this.top5Loaded = true;
      });
  }

  resetFilter() {
    this.reset = this.reset + 1;
    this.qParam = {
      // Commented out parameters: displacement, certification, ctt_reported, model_type
      // displacement: ['All'],
      // certification: ['All'],
      // ctt_reported: ['All'],
      // model_type: ['All'],
      
      // Active parameters
      internal_external: ['All'],
      customer_channel: ['All'],
      lob: ['All'],
      customer_group: ['All'],
      customer_name: ['All'],
      ecc: ['All'],
      product_line: ['All'],
      selling_location: ['All'],
      part_no_ID_21: ['All'],
    };
    
    // Commented out selectedValues
    // this.selectedValues['ctt_reported'] = ['All'];
    // this.selectedValues['displacement'] = ['All'];
    // this.selectedValues['certification'] = ['All'];
    // this.selectedValues['model_type'] = ['All'];
    
    // Active selectedValues
    this.selectedValues['internal_external'] = ['All'];
    this.selectedValues['customer_channel'] = ['All'];
    this.selectedValues['lob'] = ['All'];
    this.selectedValues['customer_group'] = ['All'];
    this.selectedValues['customer_name'] = ['All'];
    this.selectedValues['ecc'] = ['All'];
    this.selectedValues['product_line'] = ['All'];
    this.selectedValues['selling_location'] = ['All'];
    this.selectedValues['part_no_ID_21'] = ['All'];

    this.currentFilter = '';
    this.searchFilters();
    this.byTrend();
    this.getAlgorithms();
  }

  legendClick(event) {
    this.qParam.lob = [event];
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();
    }
    if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.getAlgorithms();
  }
}
